import { styles, variants, ReadonlyTextFieldTheme } from '../ReadonlyTextFieldStyles.css';
import { multiVariantStyles } from './ReadonlyTextFieldVariants.css';

const ReadonlyTextFieldRedwoodTheme: ReadonlyTextFieldTheme = {
  baseTheme: '',
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { ReadonlyTextFieldRedwoodTheme };
